// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

import {
  call,
  put,
  takeEvery
} from 'redux-saga/effects';
import * as types from './actionTypes';

import * as customerOverviewActions from './actions';
import {
  getBookshopCustomer,
} from './service';


function* getBookshopCustomerSaga({ payload }) {

  yield put(customerOverviewActions.startLoader());

  const result = yield call(getBookshopCustomer, payload);
  if (result.ok) {
    yield put(customerOverviewActions.getBookshopCustomerSuccess(result.body));
  }

  yield put(customerOverviewActions.stopLoader());
}


// The pooled-balance redemption saga that used to live here is gone: it spent
// tblBookshopCustomers.Balance, which the backend retired, and nothing could
// dispatch it once its box was removed from the page. Redemption is now
// per-voucher, in pages/redeem-voucher.
const customerOverviewSagas = [
  takeEvery(types.CUSTOMER_OVERVIEW_GET_BOOKSHOP_CUSTOMER, getBookshopCustomerSaga),
];

export default customerOverviewSagas;
